import { BloctoEvm } from './BloctoEvm.js';
export { BloctoEvm } from './BloctoEvm.js';
import { BloctoEmailConnector } from './BloctoEmailConnector.js';
export { BloctoEmailConnector } from './BloctoEmailConnector.js';

const BloctoEvmWalletConnectors = (
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_props) => [
    BloctoEvm,
    ...(_props.apiProviders.blocto ? [BloctoEmailConnector] : []),
];

export { BloctoEvmWalletConnectors };
